import { BASE_URL } from '../constants';
import { getItem } from '../utils/localStore';
import { errorHandling, errorHandler } from '../utils/errorHandling';
class logoUploadApi {
    static logoUpload(file, ext_id) {
        const TOKEN = getItem('auth_token');
        const data = new FormData();
        data.append('logo', file);
        let isError = false;
        try{
            const ajaxRequestHeaders = new Headers({
                'Authorization': TOKEN,
                mimeType: 'multipart/form-data',
            });
            let body = {
                method: 'POST',
                headers: ajaxRequestHeaders,
                body: data
            }
            return fetch(BASE_URL + `/offerings/${ext_id}/logo`, body).then(response => {

                isError = errorHandling(response);
                return response.json();
            }).catch(error => {
                if (error && !isError) {
                    errorHandler(error);
                }
                return error;
            });
        }catch(err){
        }
    }
}

export default logoUploadApi;